import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../apiConfig';
import FixtureCard from '../../../Components/UIcomponents/FixtureCard';
import Result from '../../../Components/UIcomponents/Result';

const DIVISION_ID = '128428';

const MatchesTab = () => {
    const [fixtures, setFixtures] = useState([]);
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMatches = async () => {
            try {
                const [fixturesRes, resultsRes] = await Promise.all([
                    axios.get(`${API_BASE_URL}/divisionFixture/${DIVISION_ID}`),
                    axios.get(`${API_BASE_URL}/divisionResult/${DIVISION_ID}`)
                ]);
                setFixtures(fixturesRes.data || []);
                setResults(resultsRes.data || []);
            } catch (err) {
                console.error("Error fetching matches:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchMatches();
    }, []);

    if (loading) return <div className="loader" style={{ margin: '50px auto' }}></div>;

    const styles = {
        section: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '48px',
            alignItems: 'center',
            padding: '24px 0'
        },
        titleBox: {
            display: 'flex',
            flexDirection: 'column',
            gap: '32px',
            alignItems: 'center',
            width: '100%'
        },
        title: {
            fontFamily: 'var(--fontRajdhani)',
            color: '#060D8A',
            fontSize: '28px',
            fontWeight: 700,
            margin: 0,
            textTransform: 'uppercase',
            letterSpacing: '1px'
        },
        grid: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '32px',
            width: '100%'
        }
    };

    return (
        <div style={styles.section}>
            {/* Fixtures Section */}
            <div style={styles.titleBox}>
                <h3 style={styles.title}>Upcoming Fixtures</h3>
                <div style={styles.grid}>
                    {fixtures.length > 0 ? (
                        fixtures.map((f, i) => <FixtureCard data={f} key={i} />)
                    ) : (
                        <p style={{ fontFamily: 'var(--fontRajdhani)', color: '#666' }}>No upcoming fixtures scheduled.</p>
                    )}
                </div>
            </div>

            {/* Results Section */}
            <div style={styles.titleBox}>
                <h3 style={styles.title}>Recent Results</h3>
                <div style={styles.grid}>
                    {results.length > 0 ? (
                        results.map((r, i) => <Result data={r} key={i} />)
                    ) : (
                        <p style={{ fontFamily: 'var(--fontRajdhani)', color: '#666' }}>No recent results found.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MatchesTab;
